/*
 * Copyright (C) 2015 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './bulkrestore.tpl.html';

angular
  .module('chatter.bulkrestore', [])
  .constant('BULK_RESTORE_STATE', {
    STARTED: 'STARTED',
    FINISHED: 'FINISHED'
  })
  /**
   * Controller for the chatter.bulkrestore template.
   */
  .controller(
    'ChatterBulkRestoreCtrl',
    function (
      $scope,
      httpBatch,
      $filter,
      batchUtils,
      progressFactory,
      bulkRestoreBatch,
      CHATTER_SIZES,
      BULK_RESTORE_STATE,
      $window,
      UserAgentFactory
    ) {
      var origBulkRestoreState = bulkRestoreBatch.state;

      if (origBulkRestoreState === BULK_RESTORE_STATE.FINISHED) {
        progressFactory.disableProgress();
      }

      /**
       * Utility function to set the scope vars for the batch bulkRestore
       */
      function setBulkRestoreBatchData(batch) {
        var bulkRestoreDate = moment(batch.date),
          objectTotal = batch.bulkRestoreData.totalObjects,
          objectCompleted = batch.bulkRestoreData.objectsComplete,
          stateText =
            batch.state === BULK_RESTORE_STATE.FINISHED
              ? $filter('i18n')('COMPLETED_LOWERCASE')
              : $filter('i18n')('STARTED');

        if (objectCompleted === 1 && objectTotal === 1) {
          $scope.bulkRestoreText = $filter('i18n')('BATCH_BULK_RESTORE_DETAIL_DATE_SINGLE', [
            $filter('i18n')('RESTORE'),
            stateText,
            bulkRestoreDate.format('MMM D[,] YYYY h:mm A')
          ]);
        } else {
          $scope.bulkRestoreText = $filter('i18n')('BATCH_BULK_RESTORE_DETAIL_DATE', [
            $filter('i18n')('RESTORE'),
            stateText,
            bulkRestoreDate.format('MMM D[,] YYYY h:mm A'),
            objectCompleted,
            objectTotal
          ]);
        }

        $scope.bulkRestoreBatch = batch;
        $scope.batchUtils = batchUtils;
        $scope.BULK_RESTORE_STATE = BULK_RESTORE_STATE;
      }

      // Setup the scope values for the initial load of the controller
      setBulkRestoreBatchData(bulkRestoreBatch);

      // Watches to resize the canvas app based on the current state of the backup.
      $scope.$watch('bulkRestoreInProgress ', function () {
        if (!$scope.bulkRestoreInProgress || bulkRestoreBatch.state === BULK_RESTORE_STATE.FINISHED) {
          // if the original bulkRestoreStatus was not Finished then load the batch.
          if (origBulkRestoreState !== BULK_RESTORE_STATE.FINISHED) {
            httpBatch.getBatch($scope.stateParams.batchId).then(function (batch) {
              setBulkRestoreBatchData(batch);
            });
          }
          if (!progressFactory.disabled) {
            progressFactory.disableProgress();
          }
        }
      });

      /**
       * Handler to show bulkRestore details page in app.
       */
      $scope.showBulkRestoreInApp = function () {
        // Use the chatter gotoApp function.
        $scope.gotoApp('?batchId=' + $scope.stateParams.batchId + '&page=bulkRestoreDetails');
      };

      /**
       * Handler for the download bulkRestore button.
       */
      $scope.downloadCsv = function () {
        var batchId = $scope.stateParams.batchId;

        batchUtils.downloadBulkRestoreCsv(batchId).then(function (result) {
          var blob,
            browser = UserAgentFactory.detectBrowser();
          //If it's IE do some black magic and use custom IE specific methods (MsSaveBlob) to save this file.
          if (browser && browser.indexOf('IE') > -1) {
            if (window.navigator.msSaveOrOpenBlob) {
              blob = new Blob([decodeURIComponent(encodeURI(result))], {
                type: 'text/csv;charset=utf-8;'
              });
              navigator.msSaveBlob(blob, 'BulkRestore.csv');
            }
          } else {
            $window.location.href = 'data:text/csv;charset=utf8,' + encodeURI(result);
          }
        });
      };
    }
  );
